import { render } from "./Homepage.vue?vue&type=template&id=797ce6e9"
import script from "./Homepage.vue?vue&type=script&lang=js"
export * from "./Homepage.vue?vue&type=script&lang=js"

import "./Homepage.vue?vue&type=style&index=0&id=797ce6e9&lang=scss"
script.render = render

export default script